// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileVerifiedView-commonHeaderAdmin-lck9I {
	position: fixed !important;
}

.ProfileVerifiedView-adminLayout-Ltu9e {
	padding-top: 64px !important;
}

.ProfileVerifiedView-box-FFAEg h2 {
	font-size: 21px;
	font-weight: 600;
}

.ProfileVerifiedView-exportLink-F6c53 {
	margin-bottom: -29px;
}

.ProfileVerifiedView-blockCenter-wYjiA {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.ProfileVerifiedView-panelHeader-JadQ5 {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.ProfileVerifiedView-currencyselect-p2K2R {
	width: 100%;
	margin-right: 0px;
}

.ProfileVerifiedView-panelHeader-JadQ5 {
	overflow: hidden;
	position: relative;
}

.ProfileVerifiedView-mar0-TxL7J {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.ProfileVerifiedView-blockCenter-wYjiA {
		padding: 0px;
	}

	.ProfileVerifiedView-panelHeader-JadQ5 {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.ProfileVerifiedView-sideAdminPageWrapper-jEH5o {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.ProfileVerifiedView-panelHeader-JadQ5 {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.ProfileVerifiedView-table-T5jsR {
	display: table;
}

.ProfileVerifiedView-tableRow-CBrLs {
	display: table-row;
}

.ProfileVerifiedView-tableCell-uoW_G {
	display: table-cell;
	float: none;
}

.ProfileVerifiedView-formGroup-hzwdH {
	margin-bottom: 6px;
}

.ProfileVerifiedView-select-VyY8W {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.ProfileVerifiedView-noMargin-WPytt {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.ProfileVerifiedView-exportLink-F6c53 {
	padding-top: 10px;
	padding-right: 10px;
}

.ProfileVerifiedView-labelTextNew-XkfDF {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.ProfileVerifiedView-displayInline-whAf1 {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.ProfileVerifiedView-btnUPdate-LKi43 {
	display: inline-block;
}

.ProfileVerifiedView-btnModalDelete-cRJNd {
	display: inline-block;
	margin-left: 15px;
}

.ProfileVerifiedView-radioBtn-JHar9 {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.ProfileVerifiedView-backgroundImg-NYKKb {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.ProfileVerifiedView-btnUPdate-LKi43 {
		display: block;
		margin-bottom: 12px;
	}

	.ProfileVerifiedView-btnModalDelete-cRJNd {
		display: block;
		margin-left: 0px;
	}

	.ProfileVerifiedView-btnWidth-AhU8B {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.ProfileVerifiedView-bannerImageBg-n4wLG {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.ProfileVerifiedView-bannerDelete-zhHGk {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.ProfileVerifiedView-modalRoot-h2JUS {
	padding: 32px;
}

.ProfileVerifiedView-modalBorderBottom-bseMm {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.ProfileVerifiedView-logInModalBody-DIqXt {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.ProfileVerifiedView-exportSection-QhXyn {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.ProfileVerifiedView-exportSectionGridSub-fvRph {
	grid-template-columns: 50% 49% !important;
}

.ProfileVerifiedView-exportText-i_8W0 {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.ProfileVerifiedView-exportLinkImg-q6D9S {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.ProfileVerifiedView-vtrMiddle-jHdH3 {
	vertical-align: middle;
}

.ProfileVerifiedView-exportImg-Ewngr {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ProfileVerifiedView-profileViewlabel-EqsUd {
	display: inline-block;
	width: 38%
}

.ProfileVerifiedView-profileViewMainContent-C1NN5 {
	display: inline-block;
	width: 62%;
}

.ProfileVerifiedView-profileViewMain-x_nmo {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.ProfileVerifiedView-profileViewInner-Y193J {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.ProfileVerifiedView-profileImageSection-vec0A {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.ProfileVerifiedView-lastviewInner-qF_vT {
	padding: 10px;
}

.ProfileVerifiedView-whyHostHoriLine-cP4Y3 {
	margin: 30px 0;
}

.ProfileVerifiedView-tableGrid-aHNKU {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.ProfileVerifiedView-headingContent-IwSCF {
	font-size: 18px;
	font-weight: 500;
}

.ProfileVerifiedView-refundTextColor-NAnFm {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.ProfileVerifiedView-dividerLine-fxytg {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.ProfileVerifiedView-smallContent-d4_4s {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.ProfileVerifiedView-sideAdminPageWrapper-jEH5o {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.ProfileVerifiedView-sideAdminPageWrapper-jEH5o {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.ProfileVerifiedView-exportSection-QhXyn {
		grid-template-columns: 100%;
	}

	.ProfileVerifiedView-exportSectionGridSub-fvRph {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.ProfileVerifiedView-profileViewlabel-EqsUd {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ProfileVerifiedView-profileViewMainContent-C1NN5 {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.ProfileVerifiedView-ChangeToUpperCase-FTlXM {
	text-transform: uppercase
}

.ProfileVerifiedView-noBorder-JmQL4 {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.ProfileVerifiedView-siteAdminHeading-KcUGz {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.ProfileVerifiedView-siteAdminSubHeading-kklda {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.ProfileVerifiedView-adminFormDivider-DrTdc {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.ProfileVerifiedView-space1-V_qmH {
	margin-bottom: 6px !important;
}

.ProfileVerifiedView-space2-lVBOX {
	margin-bottom: 12px !important;
}

.ProfileVerifiedView-space3-GKIqW {
	margin-bottom: 18px !important;
}

.ProfileVerifiedView-space4-pNwPK {
	margin-bottom: 24px !important;
}

.ProfileVerifiedView-space5-PI9VB {
	margin-bottom: 30px !important;
}

.ProfileVerifiedView-space6-QIuvY {
	margin-bottom: 36px !important;
}

.ProfileVerifiedView-space7-V7JX4 {
	margin-bottom: 42px !important;
}

.ProfileVerifiedView-spaceTop8-bKlkt {
	margin-bottom: 48px !important;
}

.ProfileVerifiedView-spaceTop1-t4p5w {
	margin-top: 6px !important;
}

.ProfileVerifiedView-spaceTop2-rvccE {
	margin-top: 12px !important;
}

.ProfileVerifiedView-spaceTop3-bjGih {
	margin-top: 18px !important;
}

.ProfileVerifiedView-spaceTop4-cWSby {
	margin-top: 24px !important;
}

.ProfileVerifiedView-spaceTop5-oQvdE {
	margin-top: 30px !important;
}

.ProfileVerifiedView-spaceTop6-kiJzE {
	margin-top: 36px !important;
}

.ProfileVerifiedView-spaceTop7-eiwuI {
	margin-top: 42px !important;
}

.ProfileVerifiedView-spaceTop8-bKlkt {
	margin-top: 48px !important;
}

.ProfileVerifiedView-noMargin-WPytt {
	margin: 0px !important;
}

.ProfileVerifiedView-padding1-Ef84S {
	padding-bottom: 6px !important;
}

.ProfileVerifiedView-padding2-R4_IE {
	padding-bottom: 12px !important;
}

.ProfileVerifiedView-padding3-QgAIC {
	padding-bottom: 18px !important;
}

.ProfileVerifiedView-padding4-KGs5J {
	padding-bottom: 24px !important;
}

.ProfileVerifiedView-padding5-Go8p5 {
	padding-bottom: 30px !important;
}

.ProfileVerifiedView-padding6-yKOk4 {
	padding-bottom: 36px !important;
}

.ProfileVerifiedView-padding7-w6FZY {
	padding-bottom: 42px !important;
}

.ProfileVerifiedView-paddingTop1-fxvEa {
	padding-top: 6px !important;
}

.ProfileVerifiedView-paddingTop2-ffg35 {
	padding-top: 12px !important;
}

.ProfileVerifiedView-paddingTop3-OW0w6 {
	padding-top: 18px !important;
}

.ProfileVerifiedView-paddingTop4-mW2s1 {
	padding-top: 24px !important;
}

.ProfileVerifiedView-paddingTop5-yATOO {
	padding-top: 30px !important;
}

.ProfileVerifiedView-paddingTop6-T0GB_ {
	padding-top: 36px !important;
}

.ProfileVerifiedView-paddingTop7-dhQ_i {
	padding-top: 42px !important;
}

.ProfileVerifiedView-noPadding-SoCu6 {
	padding: 0px !important;
}

.ProfileVerifiedView-textBold-x2cl7 {
	font-weight: 500 !important;
}

.ProfileVerifiedView-textBolder-X0uK1 {
	font-weight: 700 !important;
}

.ProfileVerifiedView-textNormal-yOrEt {
	font-weight: normal !important;
}

.ProfileVerifiedView-spaceBottom20-XRYBp {
	margin-bottom: 20px;
}

.ProfileVerifiedView-spaceBottom10-XN03l {
	margin-bottom: 10px;
}

.ProfileVerifiedView-marginNone-mndp6 {
	margin: 0;
}

.ProfileVerifiedView-spaceBottom15-IPWnD {
	margin-bottom: 15px;
}

.ProfileVerifiedView-marginTopNone-Hw9xT {
	margin-top: 0;
}

.ProfileVerifiedView-spaceTop11-oRnZP {
	margin-top: 11px;
}

.ProfileVerifiedView-spaceTop21-bne_x {
	margin-top: 21px;
}

.ProfileVerifiedView-spaceTop20-xqOgI {
	margin-top: 20px;
}

.ProfileVerifiedView-spaceTop10-rY5gz {
	margin-top: 10px;
}

/*New Design Text Colors */

.ProfileVerifiedView-textDarkBlue-EnE6U {
	color: rgb(20, 39, 94) !important;
}

.ProfileVerifiedView-textLightBlue-Tb4KC {
	color: rgb(57, 87, 106) !important;
}

.ProfileVerifiedView-textLightSandleGreen-PZkDh {
	color: rgb(76, 86, 41) !important;
}

.ProfileVerifiedView-textLightBrown-HWKs8 {
	color: rgb(115, 79, 33) !important;
}

.ProfileVerifiedView-textMediumMaroon-wPGip {
	color: rgb(87, 37, 51) !important;
}

.ProfileVerifiedView-textBrown-ZThmR {
	color: rgb(160, 47, 24) !important;
}

.ProfileVerifiedView-textMaroon-X55jh {
	color: rgb(155, 49, 67) !important;
}

.ProfileVerifiedView-textDarkBrown-xaQ5M {
	color: rgb(83, 18, 16) !important;
}

.ProfileVerifiedView-textMediumBrown-y1V8v {
	color: rgb(142, 28, 10) !important;
}

.ProfileVerifiedView-textSkyBlue-fCBqw {
	color: rgb(37, 117, 141) !important;
}

.ProfileVerifiedView-textGray-nz2Mj {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `ProfileVerifiedView-commonHeaderAdmin-lck9I`,
	"adminLayout": `ProfileVerifiedView-adminLayout-Ltu9e`,
	"box": `ProfileVerifiedView-box-FFAEg`,
	"exportLink": `ProfileVerifiedView-exportLink-F6c53`,
	"blockCenter": `ProfileVerifiedView-blockCenter-wYjiA`,
	"panelHeader": `ProfileVerifiedView-panelHeader-JadQ5`,
	"currencyselect": `ProfileVerifiedView-currencyselect-p2K2R`,
	"mar0": `ProfileVerifiedView-mar0-TxL7J`,
	"sideAdminPageWrapper": `ProfileVerifiedView-sideAdminPageWrapper-jEH5o`,
	"table": `ProfileVerifiedView-table-T5jsR`,
	"tableRow": `ProfileVerifiedView-tableRow-CBrLs`,
	"tableCell": `ProfileVerifiedView-tableCell-uoW_G`,
	"formGroup": `ProfileVerifiedView-formGroup-hzwdH`,
	"select": `ProfileVerifiedView-select-VyY8W`,
	"noMargin": `ProfileVerifiedView-noMargin-WPytt`,
	"labelTextNew": `ProfileVerifiedView-labelTextNew-XkfDF`,
	"displayInline": `ProfileVerifiedView-displayInline-whAf1`,
	"btnUPdate": `ProfileVerifiedView-btnUPdate-LKi43`,
	"btnModalDelete": `ProfileVerifiedView-btnModalDelete-cRJNd`,
	"radioBtn": `ProfileVerifiedView-radioBtn-JHar9`,
	"backgroundImg": `ProfileVerifiedView-backgroundImg-NYKKb`,
	"btnWidth": `ProfileVerifiedView-btnWidth-AhU8B`,
	"bannerImageBg": `ProfileVerifiedView-bannerImageBg-n4wLG`,
	"bannerDelete": `ProfileVerifiedView-bannerDelete-zhHGk`,
	"modalRoot": `ProfileVerifiedView-modalRoot-h2JUS`,
	"modalBorderBottom": `ProfileVerifiedView-modalBorderBottom-bseMm`,
	"logInModalBody": `ProfileVerifiedView-logInModalBody-DIqXt`,
	"exportSection": `ProfileVerifiedView-exportSection-QhXyn`,
	"exportSectionGridSub": `ProfileVerifiedView-exportSectionGridSub-fvRph`,
	"exportText": `ProfileVerifiedView-exportText-i_8W0`,
	"exportLinkImg": `ProfileVerifiedView-exportLinkImg-q6D9S`,
	"vtrMiddle": `ProfileVerifiedView-vtrMiddle-jHdH3`,
	"exportImg": `ProfileVerifiedView-exportImg-Ewngr`,
	"profileViewlabel": `ProfileVerifiedView-profileViewlabel-EqsUd`,
	"profileViewMainContent": `ProfileVerifiedView-profileViewMainContent-C1NN5`,
	"profileViewMain": `ProfileVerifiedView-profileViewMain-x_nmo`,
	"profileViewInner": `ProfileVerifiedView-profileViewInner-Y193J`,
	"profileImageSection": `ProfileVerifiedView-profileImageSection-vec0A`,
	"lastviewInner": `ProfileVerifiedView-lastviewInner-qF_vT`,
	"whyHostHoriLine": `ProfileVerifiedView-whyHostHoriLine-cP4Y3`,
	"tableGrid": `ProfileVerifiedView-tableGrid-aHNKU`,
	"headingContent": `ProfileVerifiedView-headingContent-IwSCF`,
	"refundTextColor": `ProfileVerifiedView-refundTextColor-NAnFm`,
	"dividerLine": `ProfileVerifiedView-dividerLine-fxytg`,
	"smallContent": `ProfileVerifiedView-smallContent-d4_4s`,
	"ChangeToUpperCase": `ProfileVerifiedView-ChangeToUpperCase-FTlXM`,
	"noBorder": `ProfileVerifiedView-noBorder-JmQL4`,
	"siteAdminHeading": `ProfileVerifiedView-siteAdminHeading-KcUGz`,
	"siteAdminSubHeading": `ProfileVerifiedView-siteAdminSubHeading-kklda`,
	"adminFormDivider": `ProfileVerifiedView-adminFormDivider-DrTdc`,
	"space1": `ProfileVerifiedView-space1-V_qmH`,
	"space2": `ProfileVerifiedView-space2-lVBOX`,
	"space3": `ProfileVerifiedView-space3-GKIqW`,
	"space4": `ProfileVerifiedView-space4-pNwPK`,
	"space5": `ProfileVerifiedView-space5-PI9VB`,
	"space6": `ProfileVerifiedView-space6-QIuvY`,
	"space7": `ProfileVerifiedView-space7-V7JX4`,
	"spaceTop8": `ProfileVerifiedView-spaceTop8-bKlkt`,
	"spaceTop1": `ProfileVerifiedView-spaceTop1-t4p5w`,
	"spaceTop2": `ProfileVerifiedView-spaceTop2-rvccE`,
	"spaceTop3": `ProfileVerifiedView-spaceTop3-bjGih`,
	"spaceTop4": `ProfileVerifiedView-spaceTop4-cWSby`,
	"spaceTop5": `ProfileVerifiedView-spaceTop5-oQvdE`,
	"spaceTop6": `ProfileVerifiedView-spaceTop6-kiJzE`,
	"spaceTop7": `ProfileVerifiedView-spaceTop7-eiwuI`,
	"padding1": `ProfileVerifiedView-padding1-Ef84S`,
	"padding2": `ProfileVerifiedView-padding2-R4_IE`,
	"padding3": `ProfileVerifiedView-padding3-QgAIC`,
	"padding4": `ProfileVerifiedView-padding4-KGs5J`,
	"padding5": `ProfileVerifiedView-padding5-Go8p5`,
	"padding6": `ProfileVerifiedView-padding6-yKOk4`,
	"padding7": `ProfileVerifiedView-padding7-w6FZY`,
	"paddingTop1": `ProfileVerifiedView-paddingTop1-fxvEa`,
	"paddingTop2": `ProfileVerifiedView-paddingTop2-ffg35`,
	"paddingTop3": `ProfileVerifiedView-paddingTop3-OW0w6`,
	"paddingTop4": `ProfileVerifiedView-paddingTop4-mW2s1`,
	"paddingTop5": `ProfileVerifiedView-paddingTop5-yATOO`,
	"paddingTop6": `ProfileVerifiedView-paddingTop6-T0GB_`,
	"paddingTop7": `ProfileVerifiedView-paddingTop7-dhQ_i`,
	"noPadding": `ProfileVerifiedView-noPadding-SoCu6`,
	"textBold": `ProfileVerifiedView-textBold-x2cl7`,
	"textBolder": `ProfileVerifiedView-textBolder-X0uK1`,
	"textNormal": `ProfileVerifiedView-textNormal-yOrEt`,
	"spaceBottom20": `ProfileVerifiedView-spaceBottom20-XRYBp`,
	"spaceBottom10": `ProfileVerifiedView-spaceBottom10-XN03l`,
	"marginNone": `ProfileVerifiedView-marginNone-mndp6`,
	"spaceBottom15": `ProfileVerifiedView-spaceBottom15-IPWnD`,
	"marginTopNone": `ProfileVerifiedView-marginTopNone-Hw9xT`,
	"spaceTop11": `ProfileVerifiedView-spaceTop11-oRnZP`,
	"spaceTop21": `ProfileVerifiedView-spaceTop21-bne_x`,
	"spaceTop20": `ProfileVerifiedView-spaceTop20-xqOgI`,
	"spaceTop10": `ProfileVerifiedView-spaceTop10-rY5gz`,
	"textDarkBlue": `ProfileVerifiedView-textDarkBlue-EnE6U`,
	"textLightBlue": `ProfileVerifiedView-textLightBlue-Tb4KC`,
	"textLightSandleGreen": `ProfileVerifiedView-textLightSandleGreen-PZkDh`,
	"textLightBrown": `ProfileVerifiedView-textLightBrown-HWKs8`,
	"textMediumMaroon": `ProfileVerifiedView-textMediumMaroon-wPGip`,
	"textBrown": `ProfileVerifiedView-textBrown-ZThmR`,
	"textMaroon": `ProfileVerifiedView-textMaroon-X55jh`,
	"textDarkBrown": `ProfileVerifiedView-textDarkBrown-xaQ5M`,
	"textMediumBrown": `ProfileVerifiedView-textMediumBrown-y1V8v`,
	"textSkyBlue": `ProfileVerifiedView-textSkyBlue-fCBqw`,
	"textGray": `ProfileVerifiedView-textGray-nz2Mj`
};
module.exports = ___CSS_LOADER_EXPORT___;
